module.exports = __webpack_public_path__ + "images/UFC_red_circle_logo-de8fa8744babf61540f74020b182cd5f.png";